import React from "react";
import styles from "./IconButton.module.scss";

export const IconButton = ({ btnStyles, icon, onClick }) => {
  return (
    <div className={`${styles.container} ${btnStyles}`} onClick={onClick}>
      {icon}
    </div>
  );
};
